<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card :loading="loading" :disabled="loading">
        <v-toolbar dark dense>
            <v-toolbar-title>Změna uživatelského hesla
                <v-chip v-if="env!=='production'" color="warning" class="mr-1">{{ env }}</v-chip>
            </v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-spacer></v-spacer>
            <v-toolbar-items class="pl-3">
                <v-btn fab x-small color="error" @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar-items>

        </v-toolbar>
        <v-card-text class="pt-6">
            <div>
                <v-alert v-if="serverError" color="error">
                    {{ serverError }}
                </v-alert>
                <v-form @keyup.native.enter="onSubmit" @submit="onSubmit" ref="form" v-if="show" autocomplete="off">
                    <v-text-field
                            label="Původní heslo"
                            v-model="form.oldPassword"
                            :error-messages="oldPasswordErrors"
                            type="password"
                            autocomplete="off"
                            required
                    ></v-text-field>
                    <v-text-field
                            label="Nové heslo"
                            v-model="form.newPassword"
                            :error-messages="passwordErrors"
                            type="password"
                            autocomplete="new-password"
                            required
                    ></v-text-field>
                    <v-text-field
                            label="Kontrola nového hesla"
                            v-model="form.confirmPassword"
                            :error-messages="confirmPasswordErrors"
                            type="password"
                            autocomplete="new-password"
                            required
                    ></v-text-field>
                    <v-card-actions>
                        <v-layout justify-space-between>
                            <v-btn @click="onSubmit" color="primary">Změnit heslo</v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
import {mapState} from 'vuex'
import {validationMixin} from "vuelidate";
import {required, sameAs, minLength} from "vuelidate/lib/validators";
import axios from "axios";

export default {
    name: 'change-user-password',
    mixins: [validationMixin],
    data() {
        return {
            env: process.env.VUE_APP_ENV,
            loading: false,
            show: true,
            serverErrors: [],
            serverError: null,
            form: {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null,
            },
        }
    },
    validations: {
        form: {
            oldPassword: {
                required,
            },
            newPassword: {
                required,
                minLength: minLength(8)
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs('newPassword')
            }

        }
    },
    computed: {
        ...mapState({
            setup: state => state.setup.setup
        }),
        oldPasswordErrors() {
            const errors = []
            if (!this.$v.form.oldPassword.$dirty) return errors
            !this.$v.form.oldPassword.required && errors.push('Prosím zadejte původní heslo')
            return errors
        },
        passwordErrors() {
            const errors = []
            if (!this.$v.form.newPassword.$dirty) return errors
            !this.$v.form.newPassword.required && errors.push('Prosím zadejte heslo')
            !this.$v.form.newPassword.minLength && errors.push('Heslo musí mít alespoň 8 znaků')
            return errors
        },
        confirmPasswordErrors() {
            const errors = [];
            if (!this.$v.form.confirmPassword.$dirty) return errors
            !this.$v.form.confirmPassword.required && errors.push('Prosím zadejte potvrzení hesla')
            !this.$v.form.confirmPassword.sameAsPassword && errors.push('Hesla se neshodují')
            return errors
        }

    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();
            this.loading = true;

            this.serverErrors = [];
            this.serverError = null;

            this.$v.form.$touch();

            if (this.form.newPassword !== this.form.confirmPassword) {
                this.$v.form.confirmPassword.$touch();
                this.loading = false;
                return false;
            }

            if (this.$v.$invalid) {
                this.loading = false;
                return false;
            }

            return axios.put(process.env.VUE_APP_TEREZA_API_URL + '/v3/user/change-password', {
                oldPassword: this.form.oldPassword,
                newPassword: this.form.newPassword
            })
                .then(() => {
                    this.$noty.success("Heslo úspěšně změněno");
                    this.$emit('onClose');
                })
                .catch((error) => {
                    if (error.response && error.response.data && Array.isArray(error.response.data)) {
                        error.response.data.forEach(err => {
                            if (err.field === 'oldPassword') {
                                if (!this.serverErrors.oldPassword) {
                                    this.serverErrors.oldPassword = [];
                                }
                                this.serverError = "Původní heslo není správné.";
                            }
                        });

                    } else {
                        const errorMessage = error.response && error.response.data
                            ? error.response.data.message || JSON.stringify(error.response.data)
                            : '' + error;
                        this.$noty.error(errorMessage);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        close() {
            this.$emit('onClose');
        }
    }
}
</script>
